import { useEffect, useState } from "react";

import { LayoutGrid, List } from 'lucide-react';

interface Props {
	title: string;
	iconNews?: boolean;
	onChange?: (value: boolean) => void;
}

export function TitlePage({ title, onChange, iconNews = false }: Props) {

	const [listGrid, setListGrid] = useState<boolean>(true);
	const [isNoticiasPage, setIsNoticiasPage] = useState<boolean>(false);

	useEffect(() => {
		if (onChange) {
			onChange(listGrid);
		}
	}, [listGrid, onChange]);

	useEffect(() => {
		const currentPath = window.location.pathname;
		setIsNoticiasPage(currentPath === "/noticias/" || currentPath === "/noticias");
	}, []);

	return (
		<div className="w-11/12 flex flex-col mt-8 lg:mt-10 lg:w-3/5">
			<div className="w-full flex flex-row justify-between items-center">
				<h1 className="text-primary dark:text-on-surface-dark font-roboto font-light text-xl lg:text-xl leading-relaxed m-0">
					{title}
				</h1>

				{isNoticiasPage && (
					<button
						className="cursor-pointer bg-transparent border-none p-2 rounded-lg text-on-surface-subtle dark:text-on-surface-dark-muted hover:bg-surface-alt dark:hover:bg-surface-dark-alt transition-colors"
						onClick={() => setListGrid(!listGrid)}
						aria-label={listGrid ? 'Visualizar em grade' : 'Visualizar em lista'}
					>
						{listGrid ? <LayoutGrid size={20} /> : <List size={20} />}
					</button>
				)}
			</div>

			<div className="flex flex-row justify-center items-end mt-3 mb-3 lg:mt-2 lg:mb-2">
				<div className="w-[5%] h-1 bg-secondary lg:h-0.5" />
				<div className="w-[95%] h-px bg-border-default dark:bg-border-default-dark" />
			</div>
		</div>
	);
}
